import * as React from "react";
import type { SVGProps } from "react";
const SvgSustainable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#352F28"
      fillRule="evenodd"
      d="M6.069 16.345c1.085-2.695 3.024-5.096 5.945-6.72a1 1 0 0 1 .972 1.75c-2.643 1.467-4.356 3.688-5.246 6.2 2.179.916 5.379.394 7.978-2.206 1.895-1.895 2.853-4.618 3.166-7.129.145-1.161.189-2.37-.015-3.528-5.606-.224-8.534-.134-11.238 2.57-3.076 3.076-3.243 6.992-1.562 9.063m-.673 2.142a6 6 0 0 1-.463-.42c-3.015-3.014-2.44-8.476 1.284-12.2 3.552-3.551 7.6-3.377 13.608-3.118l.408.018c1.198 1.198 1.531 9.385-3.1 14.016-2.909 2.909-6.878 3.896-9.913 2.752C7.072 20.345 7 21.172 7 22a1 1 0 0 1-2 0c0-1.177.13-2.36.396-3.513"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSustainable;
